import { render, staticRenderFns } from "./EditIncomeTaxSlabComponent.vue?vue&type=template&id=8c3c5916&"
import script from "./EditIncomeTaxSlabComponent.vue?vue&type=script&lang=js&"
export * from "./EditIncomeTaxSlabComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports